module.exports = __webpack_public_path__ + "img/suzuki-fronx-boostergreen.07d65d3a.jpg";